/**
 * @file MaintenancePage.tsx
 * @description 리뉴얼 중 메인테넌스 페이지 컴포넌트
 *
 * 주요 기능:
 * - NEXT_PUBLIC_RENEWAL_MODE 환경 변수가 true일 때 표시되는 메인테넌스 페이지
 * - 리뉴얼 중임을 사용자에게 알리는 간단한 UI
 *
 * 사용 방법:
 * - app/page.tsx에서 환경 변수 체크 후 조건부 렌더링
 *
 * @dependencies
 * - lucide-react: Wrench 아이콘
 */

import { Wrench } from "lucide-react";

export function MaintenancePage() {
  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-4">
          <div className="flex justify-center">
            <Wrench
              className="w-16 h-16 text-muted-foreground opacity-60"
              aria-hidden="true"
            />
          </div>
          <h1 className="text-4xl font-bold font-inter">리뉴얼 중입니다</h1>
          <p className="text-lg text-muted-foreground">
            더 나은 서비스를 위해 업데이트 중입니다.
            <br />곧 만나요!
          </p>
        </div>
      </div>
    </div>
  );
}
